var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"value":true,"color":"error","icon":"new_releases"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" "),_c('v-btn',{on:{"click":function($event){return _vm.$router.go()}}},[_vm._v("Ladda om sidan")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }